import skincareDesktopTrialOffer from 'assets/images/promoOrderSuccess/prose-man-and-woman-models-desktop.jpg';
import skincareMobileTrialOffer from 'assets/images/promoOrderSuccess/prose-man-and-woman-models-mobile.jpg';
import haircareDesktopTrialOffer from 'assets/images/promoOrderSuccess/prose-model-posing-with-haircare-trio-desktop.jpg';
import haircareMobileTrialOffer from 'assets/images/promoOrderSuccess/prose-model-posing-with-haircare-trio-mobile.jpg';

export const content = {
  US: {
    // upsell category
    haircare: {
      tracking: {
        pageView: 'Post Purchase - HC Trial Offer Embedded Module - Viewed',
      },
      twoUp: {
        image: {
          mobile: haircareMobileTrialOffer,
          desktop: haircareDesktopTrialOffer,
          imgAlt: 'Prose model posing with haircare trio',
        },
        eyebrow: 'Exclusive Offer',
        title: 'Get 50% off + free shipping when you subscribe to haircare',
        description: '',
        cta: {
          consultationCompleted: {
            label: 'Get 50% off',
            linkTo: '/checkout/haircare',
            dataClick: 'get-offer',
            dataFrom: 'post-purchase-haircare-trial-offer-embedded-module',
          },
          consultationNotCompleted: {
            label: 'Get 50% off',
            linkTo: '/consultation/haircare',
            dataClick: 'get-offer',
            dataFrom: 'post-purchase-haircare-trial-offer-embedded-module',
          },
        },
        terms: {
          label: 'Terms & Conditions',
          dataFrom: 'post-purchase-haircare-trial-offer-embedded-module',
          dataClick: 'terms-conditions',
        },
      },
      bottomModal: {
        title: 'Exclusive Offer',
        description: 'Get 50% off + free shipping when you subscribe to haircare',
        conditions: `
            50% off your first haircare subscription order. Subsequent subscription orders will receive free shipping and 15% off.
            Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions
            that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels,
            candles, and brushes [US only]), or digital gift cards. Offer subject to expire.`,
        variant: 'tertiary',
      },
    },
    // upsell category
    skincare: {
      tracking: {
        pageView: 'Post Purchase - SK Trial Offer Embedeed Module - Viewed',
      },
      twoUp: {
        image: {
          mobile: skincareMobileTrialOffer,
          desktop: skincareDesktopTrialOffer,
          imgAlt: 'Prose man & woman models',
        },
        eyebrow: 'Exclusive Offer',
        title: 'Get 50% off + free shipping when you subscribe to skincare',
        description: '',
        cta: {
          consultationCompleted: {
            label: 'Get 50% off',
            linkTo: '/checkout/skincare',
            dataClick: 'get-offer',
            dataFrom: 'post-purchase-skincare-trial-offer-embedded-module',
          },
          consultationNotCompleted: {
            label: 'Get 50% off',
            linkTo: '/consultation/skincare',
            dataClick: 'get-offer',
            dataFrom: '"post-purchase-skincare-trial-offer-embedded-module',
          },
        },
        terms: {
          label: 'Terms & Conditions',
          dataFrom: 'post-purchase-haircare-trial-offer-embedded-module',
          dataClick: 'terms-conditions',
        },
      },
      bottomModal: {
        title: 'Exclusive Offer',
        description: 'Get 50% off + free shipping when you subscribe to skincare',
        conditions: `
            50% off your first skincare subscription order. Subsequent subscription orders will receive free shipping and 15% off.
            Promotion cannot be applied to previous orders, existing subscriptions, and non-subscribed products. On-hold subscriptions
            that are reactivated during the promotional period are not eligible for the promotion. Not valid for accessories (hair towels,
            candles, and brushes [US only]), or digital gift cards. Offer subject to expire.`,
        variant: 'tertiary',
      },
    },
  },
};
